<template>
  <div class="hello">
    <h1 v-if="valid">Vidéo-Assistance</h1>

    <p v-if="valid">
      Cliquez sur le bouton ci-dessous pour démarrer l'outil de vidéoassistance.
    </p>

    <p v-else>
      Le lien n'est pas valide ou a expiré.
    </p>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      valid: false
    };
  },

  async mounted() {
    const params = new URLSearchParams(window.location.search);

    const uid = params.get("uid");
    const exp = params.get("exp");
    const sig = params.get("sig");

    if (!uid || !exp || !sig) {
      this.valid = false;
      return;
    }

    try {
      const now = Math.floor(Date.now() / 1000);

      // Optional UX check (not security)
      if (now > parseInt(exp)) {
        this.valid = false;
        return;
      }

      const res = await fetch(
        `https://vt0ue1okw2.execute-api.eu-west-3.amazonaws.com/Prod/verify-video-url?uid=${encodeURIComponent(uid)}&exp=${encodeURIComponent(exp)}&sig=${encodeURIComponent(sig)}`
      );

      const data = await res.json();

      this.valid = data.valid === true;

    } catch (err) {
      console.error("Erreur lors de la vérification :", err);
      this.valid = false;
    }
  }
};
</script>